module.exports = __webpack_public_path__ + "img/img_015@2x.d3f48700.png";